import React from "react";
import { action, observable } from "mobx";
import * as Api from "api";
import * as Agency from "api/admin/Agency";

interface Value {
  id?: number;
  name?: string;
}

export class FormStore {
  public errors = new Api.Error<Agency.CreateParams>();

  @observable.ref
  public open = false;

  @observable
  public value: Value = {};

  @action.bound
  public modal(open: boolean, value?: Value) {
    this.open = open;
    this.errors.clear();
    this.value = value || {};
  }

  public async save() {
    this.errors.clear();

    const response = this.value.id
      ? await Agency.Api.update(this.value.id, this.value)
      : await Agency.Api.create(this.value);

    if (response?.status === Api.Status.OK) {
      this.modal(false);
      return true;
    }

    this.errors.set(response?.data);

    return false;
  }
}

const Context = React.createContext<FormStore | null>(null);

export const FormStoreProvider: React.FC<{ value?: FormStore }> = ({
  children,
  value,
}) => {
  const store = React.useMemo(() => (value ? value : new FormStore()), [value]);
  return <Context.Provider value={store}>{children}</Context.Provider>;
};

export const useFormStore = () => {
  const formStore = React.useContext(Context);
  if (!formStore) {
    throw new Error("useFormStore must be used within a FormStoreProvider.");
  }
  return formStore;
};
